<template>
  <div class="layout__position-left layout__width-100 layout__margin__bottom-10">
    <el-button
      class="button-teal button__base button__insights"
      :disabled="this.sales.length === 0"
      @click="csv"
    >
      Download CSV
    </el-button>
  </div>
</template>

<script>
import Axios from 'axios';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import NoSpendClients from '../../enums/NoSpendClients';
import moment from 'moment';

export default {
  name: 'NoSpendSearch',

  mixins: [axios, csvDownloadHelper, dataFormatter],

  props: {
    searchParams: {},

    sales: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isLoading: false,
      serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
      exportDate: new Date().toLocaleDateString('en-GB') + '_no_spend.csv',
      noSpendClients: NoSpendClients,
      downloadUrl: '',
    };
  },

  watch: {
    currentPage() {
      this.getSales();
    },

    total() {
      this.getSales();
    },
  },

  computed: {
    currentPage() {
      return this.searchParams.currentPage;
    },

    total() {
      return this.searchParams.total;
    },
  },

  mounted() {
    this.getSales();
  },

  methods: {
    formatSpends(amount) {
      return this.formatCurrencyTwoPlaces(amount ? amount : 0);
    },

    getSales() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      const endpoint = `${this.serviceRouteUrl}/api/v1/DynamicQuery/GetNoSpend?getCount=0&cnt=${this.searchParams.pagination}&start=${this.searchParams.pagination * (this.searchParams.currentPage - 1)}`;

      this.$parent.loading = true;

      Axios.get(endpoint, this.returnHeaderUsingToken())
        .then(response => {
          const spendFields = [
            'avgorder',
            'toolkit',
            'email',
            'bespoke',
            'instantprint',
            'photofixr',
            'myravensworth',
            'delivery',
            'net_total',
          ];

          let noSpendClients = response.data;

          noSpendClients = noSpendClients.map((noSpendClient) => {
            spendFields.forEach((field) => {
              noSpendClient[field] = this.formatSpends(noSpendClient[field]);
            });

            noSpendClient['last_order'] = noSpendClient['last_order']
              ? moment(noSpendClient['last_order']).format('DD/MM/YYYY')
              : '';

            return {
              ...noSpendClients,
            };
          });

          this.$parent.sales = response.data?.length ? response.data : [];

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$parent.loading = false;
          });

          this.isLoading = false;
        })
        .catch(error => {
          if (error.response) {
            this.$message.error('Sorry there has been an issue retrieving the information you requested.');
          }

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$parent.loading = false;
          });

          this.$parent.sales = [];

          this.isLoading = false;
        });
    },

    csv() {
      const fields = this.noSpendClients.createLabelValueList();

      this.downloadCsv(this.exportDate, fields, this.sales);
    },
  },
};
</script>